module.exports = __webpack_public_path__ + "media/hyper/fonts/dripicons-v2-09c9c870ef8f9cffcc8faf6091535231.ttf";